module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-03.4236032d.jpg";